import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtePanelComponent } from './rte-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TextModule } from '../lib/ui-kit/text/text.module';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    RtePanelComponent],
  exports: [
    RtePanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    [LottieModule.forRoot({ player: playerFactory })]
  ],
})
export class RtePanelModule { }
